import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default, { useRef } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { useMenuContext, usePaneContext, ItemContextProvider } from './MenuContext.js';
import styles from './Menu2.js';
import useSelectContext from '../Select/SelectContext.js';
import { VIRTUOSO_PROPS } from './constants.js';

const PaneChildren = _ref => {
  var _useSelectContext, _containerRef$current, _containerRef$current2;
  let {
    children
  } = _ref;
  const {
    virtuoso
  } = useMenuContext();
  const {
    multiselect,
    showSelectedItemsPane
  } = (_useSelectContext = useSelectContext(true)) !== null && _useSelectContext !== void 0 ? _useSelectContext : {};
  const {
    closeSubmenu: containedWithinSubpane,
    setIsVirtualizationReady,
    isVirtualized
  } = usePaneContext();
  const containerRef = useRef(null);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: containerRef,
    className: styles.scrollContainer,
    style: {
      maxHeight: "calc(var(--flyout-max-height) -\n                ".concat((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetTop, "px -\n                var(--flyout-bottom-padding))")
    }
  }, isVirtualized ? /*#__PURE__*/React__default.createElement(Virtuoso, _extends({
    ref: virtuoso,
    startReached: () => setIsVirtualizationReady === null || setIsVirtualizationReady === void 0 ? void 0 : setIsVirtualizationReady(true),
    customScrollParent: (_containerRef$current2 = containerRef.current) !== null && _containerRef$current2 !== void 0 ? _containerRef$current2 : undefined,
    data: Array.isArray(children) ? children : [children]
    // eslint-disable-next-line react/no-unstable-nested-components
    ,
    itemContent: (index, child) => ! /*#__PURE__*/React__default.isValidElement(child) ? null : /*#__PURE__*/React__default.createElement(ItemContextProvider, {
      value: {
        virtualIndex: index + (multiselect && showSelectedItemsPane && !containedWithinSubpane ? 1 : 0)
      }
    }, child)
  }, VIRTUOSO_PROPS)) : /*#__PURE__*/React__default.createElement(ItemContextProvider, {
    value: {
      virtualIndex: undefined
    }
  }, children));
};

export { PaneChildren as default };
